import React from "react";
import {
  Briefcase,
  FileText,
  Mic,
  BookOpen,
  Wand2,
  Wrench,
  Sparkles,
  ArrowUpRight,
} from "lucide-react";

const features = [
  {
    title: "Live ATS Job Board",
    body: "338,947+ jobs pulled straight from Greenhouse, Lever, Ashby, Workday — never from repost aggregators. Apply where the recruiter actually reads.",
    icon: Briefcase,
    bg: "bg-[#FFE600]",
    fg: "text-[#0a0a0a]",
    span: "lg:col-span-7 lg:row-span-2",
    tag: "FLAGSHIP",
  },
  {
    title: "ATS Resume Builder + Match",
    body: "Hyperlink certification matching, 0-100 match score against live roles, 4 design styles. Beat the bots before a human sees you.",
    icon: FileText,
    bg: "bg-[#0055FF]",
    fg: "text-white",
    span: "lg:col-span-5 lg:row-span-1",
    tag: "ATS-PROOF",
  },
  {
    title: "AI Interview & Sales Role-Play",
    body: "Live voice role-play with brutal teach-back grading. Interviewer mode, cold-call mode, objection handling.",
    icon: Mic,
    bg: "bg-[#FDFBF7]",
    fg: "text-[#0a0a0a]",
    span: "lg:col-span-5 lg:row-span-1",
    tag: "VOICE AI",
  },
  {
    title: "100+ Grounded Playbooks",
    body: "Every guide carries a Grounded score with source-reported numbers. Income & job playbooks, from freelance to SaaS.",
    icon: BookOpen,
    bg: "bg-[#00FF66]",
    fg: "text-[#0a0a0a]",
    span: "lg:col-span-4",
    tag: "PLAYBOOKS",
  },
  {
    title: "Content Machine (OmniCut)",
    body: "Frame-by-frame viral edit blueprints, hook writer, thumbnail prompt engine. Print attention on demand.",
    icon: Wand2,
    bg: "bg-[#FF3B30]",
    fg: "text-white",
    span: "lg:col-span-4",
    tag: "GROWTH",
  },
  {
    title: "Tool & Repo Directory",
    body: "252 vetted entries · 86 categories. Tools, prompts, GitHub repos and GPTs — the unfair stack other founders pay for.",
    icon: Wrench,
    bg: "bg-[#FDFBF7]",
    fg: "text-[#0a0a0a]",
    span: "lg:col-span-4",
    tag: "STACK",
  },
];

export default function Features() {
  return (
    <section
      id="features"
      data-testid="features"
      className="border-b-4 border-[#0a0a0a] bg-[#FDFBF7]"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 reveal">
          <div className="max-w-2xl">
            <div className="font-accent text-sm bg-[#0a0a0a] text-[#FFE600] inline-block px-3 py-1 mb-4">
              ★ THE TOOLKIT
            </div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl">
              Everything
              <br />
              <span className="bg-[#0055FF] text-white px-2">an unfair</span>{" "}
              operator
              <br />
              needs. In one tab.
            </h2>
          </div>
          <p className="font-mono-body text-base text-[#0a0a0a]/70 max-w-md">
            Stop juggling 14 SaaS subscriptions. Stop applying to ghost
            listings. JobHacki is the entire stack — board, builder, prep,
            playbooks, content, tools — for less than a coffee.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8">
          {features.map((f, idx) => {
            const Icon = f.icon;
            return (
              <article
                key={f.title}
                data-testid={`feature-${idx}`}
                className={`${f.span} ${f.bg} ${f.fg} border-4 border-[#0a0a0a] shadow-brutal hover-pop p-6 md:p-8 flex flex-col gap-5 min-h-[260px] relative reveal`}
              >
                <div className="flex items-start justify-between">
                  <div className="w-14 h-14 bg-[#0a0a0a] text-[#FFE600] border-2 border-[#0a0a0a] flex items-center justify-center">
                    <Icon size={28} strokeWidth={2.5} />
                  </div>
                  <span className="font-accent text-xs bg-[#0a0a0a] text-[#FFE600] px-2 py-1">
                    {f.tag}
                  </span>
                </div>

                <div>
                  <h3 className="font-display text-2xl md:text-3xl leading-tight mb-2">
                    {f.title}
                  </h3>
                  <p className="font-mono-body text-sm md:text-base leading-relaxed opacity-90">
                    {f.body}
                  </p>
                </div>

                <div className="mt-auto flex items-center justify-between font-accent text-sm">
                  <span className="inline-flex items-center gap-1">
                    <Sparkles size={14} strokeWidth={2.5} /> Included in All-Access
                  </span>
                  <ArrowUpRight size={20} strokeWidth={3} />
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
